import React from 'react';
import{connect} from "react-redux";
import {teamSiteUrlFormate}  from "../../../../utils/dateFormate";
import ReactHtmlParser from 'html-react-parser';
const BookSubMenuMobile = ({bookSubMenuData, backNavFunc, showSubMenu, $mainMenuLinkTxt, $customeProfileDetails }) => {
    const {REACT_APP_IMAGEURL} = window.weeksWebCloudConfig;
    return (
        
        <div className={`slide-menu-container ${showSubMenu === "BOOK" ? "slide-in" : "slide-out"}`}>
            <div className="col-12 border-bottom">
                <a className="points-x-small bold py-3 d-block black-link-color" href="#!"  onClick={backNavFunc}><img src={`${REACT_APP_IMAGEURL}/static/images/rebrand-ds/Arrow-left.png`} width="24px" height="24px"/>{$mainMenuLinkTxt}</a>
            </div>
            <div className="pt-3">
            <div className="sub-menu-heading pb-2 px-3">{bookSubMenuData.DisplayText}</div>
            <ul className="mobile-nav">
            {
                $customeProfileDetails.memberStatus !== "C1" ?
                bookSubMenuData.SearchInfo.ImageContainer.map((data,index)=>{
                        return(
                            <li className="py-2 px-3" key={index}>
                                <a href={teamSiteUrlFormate(data.URL)}>
                                    <img src={REACT_APP_IMAGEURL+data.MobileLinkIcon} 
                                    alt="" 
                                    className="d-inline"/> 
                                    {ReactHtmlParser(data.DisplayText)}
                                </a>
                            </li>
                        )
                    }):
                    <li className="py-2 px-3" >
                    <a href={teamSiteUrlFormate(bookSubMenuData.SearchInfo.ImageContainer[0].URL)}>
                        <img src={REACT_APP_IMAGEURL+bookSubMenuData.SearchInfo.ImageContainer[0].MobileLinkIcon} 
                        alt="" 
                        className="d-inline"/> 
                        {ReactHtmlParser(bookSubMenuData.SearchInfo.ImageContainer[0].DisplayText)}
                    </a>
                </li>
                }
                {
                    bookSubMenuData.Links.map((data,index)=>{
                        return(
                            <li className="py-2 px-3" key={index}>
                                <a href={teamSiteUrlFormate(data.URL)}>
                                    <img src={REACT_APP_IMAGEURL+data.MobileLinkIcon} alt="" className="d-inline"/> 
                                    <span className="d-inline">{ReactHtmlParser(data.DisplayText)}</span>
                                </a>
                            </li>
                        )
                    })
                }
                {
                $customeProfileDetails.memberStatus !== "C1" ?
                bookSubMenuData.TravelInfo !== undefined &&    
                bookSubMenuData.TravelInfo.LinksInfo.map((data,index)=>{
                        return(
                            <li className="py-2 px-3" key={index}>
                                <a href={teamSiteUrlFormate(data.URL)}>
                                    <img src={REACT_APP_IMAGEURL+data.IconImage} alt="" className="d-inline"/> 
                                    <span className="d-inline">{ReactHtmlParser(data.DisplayText)}</span>
                                </a>
                            </li>
                        )
                    })
                    : false
                }
            </ul> 
        </div>
        </div>
        
    )
}

export default connect()(BookSubMenuMobile)
